import script from "./MetaFormRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./MetaFormRenderer.vue?vue&type=script&setup=true&lang=js"

import "./MetaFormRenderer.vue?vue&type=style&index=0&id=6afa9b0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6afa9b0d"]])

export default __exports__